/**
 * Service for generating URLs to League of Legends assets from Data Dragon
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Mapping of spell IDs to their keys
var SUMMONER_SPELL_MAP = {
    21: "SummonerBarrier",
    1: "SummonerBoost",
    14: "SummonerDot",
    3: "SummonerExhaust",
    4: "SummonerFlash",
    6: "SummonerHaste",
    7: "SummonerHeal",
    13: "SummonerMana",
    30: "SummonerPoroRecall",
    31: "SummonerPoroThrow",
    11: "SummonerSmite",
    39: "SummonerSnowURFSnowball_Mark",
    32: "SummonerSnowball",
    12: "SummonerTeleport",
    54: "Summoner_UltBookPlaceholder",
    55: "Summoner_UltBookSmitePlaceholder",
};
var AssetService = /** @class */ (function () {
    function AssetService() {
    }
    /**
     * Initialize the version promise
     */
    AssetService.initVersionPromise = function () {
        return AssetService.loadLatestVersion();
    };
    /**
     * Internal method to load the latest version from Riot API
     */
    AssetService.loadLatestVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, versions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("https://ddragon.leagueoflegends.com/api/versions.json")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        versions = _a.sent();
                        return [2 /*return*/, versions[0]];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error fetching latest version:", error_1);
                        return [2 /*return*/, this.defaultVersion];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the latest League of Legends version
     */
    AssetService.getVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.versionPromise];
            });
        });
    };
    /**
     * Get the URL for a summoner profile icon
     */
    AssetService.getSummonerProfileIcon = function (profileIconId) {
        return __awaiter(this, void 0, void 0, function () {
            var version;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!profileIconId)
                            return [2 /*return*/, ""];
                        return [4 /*yield*/, this.getVersion()];
                    case 1:
                        version = _a.sent();
                        return [2 /*return*/, "https://ddragon.leagueoflegends.com/cdn/".concat(version, "/img/profileicon/").concat(profileIconId, ".png")];
                }
            });
        });
    };
    /**
     * Get the summoner spell key from the spell ID
     */
    AssetService.getSummonerSpellKey = function (spellId) {
        return SUMMONER_SPELL_MAP[spellId] || "";
    };
    /**
     * Get the URL for a summoner spell icon
     */
    AssetService.getSummonerSpellIcon = function (spellId) {
        return __awaiter(this, void 0, void 0, function () {
            var version, spellKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!spellId)
                            return [2 /*return*/, ""];
                        return [4 /*yield*/, this.getVersion()];
                    case 1:
                        version = _a.sent();
                        spellKey = this.getSummonerSpellKey(spellId);
                        if (!spellKey)
                            return [2 /*return*/, ""];
                        return [2 /*return*/, "https://ddragon.leagueoflegends.com/cdn/".concat(version, "/img/spell/").concat(spellKey, ".png")];
                }
            });
        });
    };
    /**
     * Get the URLs for rune icons
     */
    AssetService.getRuneIcon = function (primaryRuneId, primaryRuneStyleId, secondaryRuneStyleId, runeData) {
        var _a;
        if (!primaryRuneId || !primaryRuneStyleId || !secondaryRuneStyleId || !runeData.length)
            return null;
        var baseUrl = "https://ddragon.leagueoflegends.com/cdn/img/";
        var primaryRuneStyle = runeData.find(function (rune) { return rune.id === parseInt(primaryRuneStyleId); });
        var secondaryRuneStyle = runeData.find(function (rune) { return rune.id === parseInt(secondaryRuneStyleId); });
        var primaryRune = (_a = primaryRuneStyle === null || primaryRuneStyle === void 0 ? void 0 : primaryRuneStyle.slots.find(function (slot) { return slot.runes.some(function (rune) { return rune.id === parseInt(primaryRuneId); }); })) === null || _a === void 0 ? void 0 : _a.runes.find(function (rune) { return rune.id === parseInt(primaryRuneId); });
        if (!(primaryRune === null || primaryRune === void 0 ? void 0 : primaryRune.icon) || !(secondaryRuneStyle === null || secondaryRuneStyle === void 0 ? void 0 : secondaryRuneStyle.icon))
            return null;
        var runes = {
            primaryRune: "".concat(baseUrl).concat(primaryRune === null || primaryRune === void 0 ? void 0 : primaryRune.icon),
            secondaryRune: "".concat(baseUrl).concat(secondaryRuneStyle === null || secondaryRuneStyle === void 0 ? void 0 : secondaryRuneStyle.icon)
        };
        return runes;
    };
    /**
     * Get the base URL for Data Dragon
     */
    AssetService.getDataDragonBaseUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var version;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVersion()];
                    case 1:
                        version = _a.sent();
                        return [2 /*return*/, "https://ddragon.leagueoflegends.com/cdn/".concat(version, "/data/en_US")];
                }
            });
        });
    };
    /**
     * Get the URL for runes reforged data
     */
    AssetService.getRunesReforgedUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataDragonBaseUrl()];
                    case 1:
                        baseUrl = _a.sent();
                        return [2 /*return*/, "".concat(baseUrl, "/runesReforged.json")];
                }
            });
        });
    };
    /**
     * Fetch runes data
     */
    AssetService.fetchRunesData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.getRunesReforgedUrl()];
                    case 1:
                        url = _a.sent();
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _a.sent();
                        return [2 /*return*/, data];
                    case 4:
                        error_2 = _a.sent();
                        console.error("Error fetching runes data:", error_2);
                        return [2 /*return*/, []];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Default version to use as fallback
    AssetService.defaultVersion = "13.24.1";
    // Cache the latest version
    AssetService.versionPromise = AssetService.initVersionPromise();
    return AssetService;
}());
export { AssetService };
export default AssetService;
